import { render } from "./AcademicEngagementModal.vue?vue&type=template&id=3491398c"
import script from "./AcademicEngagementModal.vue?vue&type=script&lang=js"
export * from "./AcademicEngagementModal.vue?vue&type=script&lang=js"
script.render = render

export default script